<template>
    
    <div class="form__root" :data-name="originForm">
        <div class="form__container" ref="formContainer" :style="{ 'transform': 'translate3d(0px,' + transitionInit +'%, 0px)' }">
            <form @submit.prevent="validateForm('form1')" class="form" :class="{ 'hided': form1}" data-vv-scope="form1">

                <div class="form__input" >
                    <input type="text" name="company" ref="name" v-model="inputName.company" v-validate="'required|alpha_spaces'" :placeholder="fieldsData.company" class="input" :class="{'danger': errors.has('form1.company') }" id="q1">

                    <input type="text" name="name" ref="name" v-model="inputName.name" v-validate="'required|alpha_spaces'" :placeholder="fieldsData.name" class="input" :class="{'danger': errors.has('form1.name') }" id="q2">
                    <input type="text" name="workEmail" ref="workEmail" v-model="inputName.workEmail" v-validate="'required|email'" :placeholder="fieldsData.workEmail" class="input" :class="{'danger': errors.has('form1.workEmail') }" id="q3">
                    <input type="text" name="country" ref="country" v-model="inputName.country" v-validate="'required'" :placeholder="fieldsData.country" class="input" :class="{'danger': errors.has('form1.country') }" id="q4">

                     <input type="text" name="workPhone" ref="workPhone" v-model="inputName.workPhone" v-validate="'required|alpha_num_space'"
                    :placeholder="fieldsData.workPhone" class="input" :class="{'danger': errors.has('form4.workPhone') }" id="q5">
                    <div class="t-center" :class="{ 'hide': form1}">
                        <button type="submit" class="cta" id="f_step1">{{ctaLabel}}</button>
                    </div>
                </div>

            </form>

            <form @submit.prevent="validateForm('form2')" class="form" :class="{ 'hided': form2}" data-vv-scope="form2">
                <div class="form__thanks" style="width:100%">
                    <div class="form__input" >
                        <p style="width:100%">{{ fieldsData.thanks }}</p>
                    </div>
                </div>

            </form>
            
            <form @submit.prevent="validateForm('form3')" id="form3" class="form" :class="{ 'hided': form3}" data-vv-scope="form4">
                <div class="form__input" >
                    <input type="text" name="companySize" ref="companySize" v-model="inputName.companySize" v-validate="'required|alpha_num_space'" :placeholder="fieldsData.companySize" class="input" :class="{'danger': errors.has('form4.companySize') }" id="q5">
                    <span v-show="errors.has('form4.companySize')" class="help is-danger">{{ errors.first('form4.companySize') }}</span>
                    
                    <input type="text" name="functionLevel" ref="functionLevel" v-model="inputName.functionLevel" v-validate="'required|alpha_num_space'" :placeholder="fieldsData.functionLevel" class="input" :class="{'danger': errors.has('form4.functionLevel') }" id="q6">
                    <span v-show="errors.has('form4.functionLevel')" class="help is-danger">{{ errors.first('form4.functionLevel') }}</span>
                    
                    <button type="submit" ref="cta" class="cta" style="display: none">{{ctaLabel}}</button>
                    <div class="t-center" style="margin-top: 10px" :class="{ 'hide': form4}">
                        <button v-show="inputName.companySize !== '' && inputName.functionLevel !== ''" type="submit" id="f_step4" class="arrow__down"></button>
                    </div>
                </div>
            </form>
            
            <form @submit.prevent="validateForm('form4')" class="form" :class="{ 'hided': form4}" data-vv-scope="form5">
                <div class="form__input" >
                    <input type="text" name="workPhone" ref="workPhone" v-model="inputName.workPhone" v-validate="'required|alpha_num_space'"
                    :placeholder="fieldsData.workPhone" class="input" :class="{'danger': errors.has('form4.workPhone') }" id="q7">
                    <span v-show="errors.has('form5.workPhone')" class="help is-danger">{{ errors.first('form4.workPhone') }}</span>
                    
                    <div class="t-center">
                        <button type="submit" id="f_end" ref="cta" class="cta">{{ctaLabel}}</button>
                    </div>
                </div>
            </form>
            <div class="form__thanks">
                <div class="form__input" >
                    <p>{{ fieldsData.thanks }}</p>
                </div>
            </div>
            
            <!-- get origin section -->
            <input type="hidden" :value="originSection">
        </div>
    </div>

</template>
<script>
/* eslint-disable */
import {formFields} from '../contents/common.json'
import Country from '../contents/country.json'
import axios from 'axios'
import alpha_spaces from '../helpers/rules-alphanumerics'
export default {
  props: ['originForm', 'ctaLabel', 'originSection'],
  name: 'FormRequest',
  data () {
    return {
      country: Country,
      fieldsData: formFields,
      form1: false,
      form2: false,
      form3: false,
      form4: false,
      inputName: {
        'company': '',
        'name': '',
        'workEmail': '',
        'country': '',
        'companySize': '',
        'functionLevel': '',
        'workPhone': '',
        'originForm': '',
        'originSectionForm': ''
      },
      errorPost: [],
      transitionInit: 0,
      transitionValue: -100
    }
  },
  methods: {
    validateForm (scope) {
      // let _this = this
      this.$validator.validateAll(scope).then((result) => {
        if ( result ) {
            switch (scope) {
                case 'form1':
                    this.form1 = result
                    this.transitionInit = this.transitionValue
                    // focus on next input when transition is ended
                    // this.$refs.formContainer.addEventListener('transitionend', () => {
                    //     // set timeout to avoid jump of div due to focus input
                    //     setTimeout(() => {
                    //         this.$refs.country.focus()
                    //     }, 500)
                    // })
                    break;                
                case 'form2':
                    if (this.inputName.country !== '') {
                        this.form2 = result
                        this.transitionInit = this.transitionInit + this.transitionValue

                    }
                    // focus on next input when transition is ended
                    // this.$refs.formContainer.addEventListener('transitionend', () => {
                    //     // set timeout to avoid jump of div due to focus input
                    //     setTimeout(() => {
                    //         this.$refs.industry.focus()
                    //     }, 0)
                    // })
                    break;
                
                case 'form3':
                    this.form3 = result
                    this.transitionInit = this.transitionInit + this.transitionValue
                    // focus on next input when transition is ended
                    this.$refs.formContainer.addEventListener('transitionend', () => {
                        // set timeout to avoid jump of div due to focus input
                        setTimeout(() => {
                            this.$refs.companySize.focus()
                        }, 0)
                    })
                    break;
                
                case 'form4':
                    this.form4 = result
                    this.transitionInit = this.transitionInit + this.transitionValue
                    // focus on next input when transition is ended
                    this.$refs.formContainer.addEventListener('transitionend', () => {
                        // set timeout to avoid jump of div due to focus input
                        setTimeout(() => {
                            this.$refs.workPhone.focus()
                        }, 500)
                        
                    })
                    break;  
                default:
                    break;
            }
        }

        // @object to send => this.inputName
        // Test Ajax Post with a fake service
        // Replace url by your own.
        if ( this.form1) {
            console.log('post form')
            axios.post(`/ajax/sendmail.php`, {
                body: this.inputName
            })
            .then(response => {
                console.log(response)
            })
            .catch(e => {
                this.errorPost.push(e)
            })
        } 
      })
    }
  },
  computed: {
      getOrigin () {
          this.inputName.originForm = this.originForm
          this.inputName.originSectionForm = this.originSection
      }
  },
  mounted () {
    // get origin of form
    // it's emitted by the parent component
    // this.$bus.$on('origin-form', (data) => {
    //   this.inputName.originForm = data
    // })
    // this.$bus.$on('originSection-form', (data) => {
    //   this.inputName.originSectionForm = data
    // })
    this.getOrigin
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Form.vue